module.exports = __webpack_public_path__ + "img/kq／pic.7bda199a.png";